import * as React from "react";
import type {
  MatchingSkillBannerController,
  ReplaceSkillRunInput,
} from "../hooks/useMatchingSkillBanner";
import type { SkillDecisionSkill } from "../types";
import { SkillDecisionBanner } from "./SkillDecisionBanner";

export type { ReplaceSkillRunInput };

export interface MatchingSkillBannerSlotProps {
  banner?: MatchingSkillBannerController;
  onViewSkill: (skill: SkillDecisionSkill) => void;
  onReplaceSkillRun?: (input: ReplaceSkillRunInput) => Promise<unknown>;
}

/** Shared composer placement for the matching-skill banner. */
export const MatchingSkillBannerSlot: React.FC<MatchingSkillBannerSlotProps> = ({
  banner,
  onViewSkill,
  onReplaceSkillRun,
}) => {
  if (!banner?.state) return null;

  const { state, runWithSkills, runWithoutSkills, dismiss } = banner;

  return (
    <div className="mb-1.5 min-w-0">
      <SkillDecisionBanner
        decision={state.decision}
        onViewSkill={onViewSkill}
        onRunWithSkills={(skills) => {
          if (!onReplaceSkillRun) return;
          void runWithSkills(skills, onReplaceSkillRun);
        }}
        onRunWithoutSkills={() => {
          if (!onReplaceSkillRun) return;
          void runWithoutSkills(onReplaceSkillRun);
        }}
        onDismiss={dismiss}
        stoppingRun={state.stoppingRun}
        runError={state.runError}
      />
    </div>
  );
};
